/*
 * Copyright (c) 2020 WildFireChat. All rights reserved.
 */

export default class ConversationType {
    static Single = 0;
    static Group = 1;
    static ChatRoom = 2;
    static Channel = 3;
    static SecretChat = 5;
}
